import { getCurrentInstance, onBeforeUnmount, ref } from 'vue';
import { resolveMethodName } from './mapping';
export function createService({ connection, 
// eslint-disable-next-line @typescript-eslint/no-empty-function
failFn = () => { }, autoOffInsideComponentScope = true, }) {
    const connected = ref(false);
    const invokeQueue = [];
    const activeListenersSet = new Set();
    connection.onclose(failFn);
    async function init() {
        try {
            await connection.start();
            connected.value = true;
            while (invokeQueue.length) {
                const action = invokeQueue.shift();
                // "action?.()" syntax isn't transpiled by TS due to esnext target
                // and would break projects using the package
                action && action();
            }
        }
        catch (error) {
            failFn(error);
        }
    }
    function invoke(methodName, ...payload) {
        return new Promise((resolve, reject) => {
            const invokeFn = () => connection
                .invoke(resolveMethodName(methodName), ...payload)
                .then(resolve)
                .catch(reject);
            if (connected.value) {
                void invokeFn();
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                invokeQueue.push(invokeFn);
            }
        });
    }
    function on(methodName, callback, { skip, once } = {}) {
        const originalMethodName = resolveMethodName(methodName);
        connection.on(originalMethodName, (...payload) => {
            // Needed to make TS happy with a cast
            const _payload = payload;
            if (skip && skip(..._payload)) {
                return;
            }
            if (once) {
                off(methodName, callback);
            }
            callback(..._payload);
        });
        if (autoOffInsideComponentScope) {
            // Auto-unregister listener if inside a component
            const instance = getCurrentInstance();
            if (instance) {
                activeListenersSet.add(callback);
                onBeforeUnmount(() => {
                    if (activeListenersSet.delete(callback)) {
                        off(methodName, callback);
                    }
                });
            }
        }
    }
    function once(methodName, callback, options = {}) {
        on(methodName, callback, { ...options, once: true });
    }
    function off(methodName, callback) {
        const originalMethodName = resolveMethodName(methodName);
        if (callback) {
            connection.off(originalMethodName, (...payload) => {
                // Needed to make TS happy with a cast
                const _payload = payload;
                callback(..._payload);
            });
        }
        else {
            connection.off(originalMethodName);
        }
    }
    return {
        init,
        connected,
        invoke,
        on,
        off,
        once,
    };
}
//# sourceMappingURL=service.js.map